import { SyntheticEvent, useEffect, useState } from 'react'
import TwoColumnLayout from '../../layouts/two-column-layout/two-column-layout'
import CommissionDetails from './commission-details/commission-details'
import CommissionSelection from './commission-selection/commission-selection'
import { useLazyGetCommissionsQuery } from 'store/commissions/commissions.api'
import { getUserId } from 'utils/common'

const CommissionPage = () => {
  const [tabsValue, setTabsValue] = useState(0)
  const [selectedWeek, setSelectedWeek] = useState<number | undefined>(undefined)
  const [getCommissions] = useLazyGetCommissionsQuery()
  const userId = getUserId()

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setTabsValue(newValue)
  }

  const handleWeekChange = (week: number | undefined) => {
    setSelectedWeek(week)
  }

  useEffect(() => {
    if (userId) {
      const status = tabsValue === 0 ? 'NOT_PAID' : 'PAID'
      getCommissions({
        userId,
        week: selectedWeek,
        status,
      })
    }
  }, [getCommissions, tabsValue, selectedWeek, userId])

  return (
    <TwoColumnLayout>
      <CommissionSelection
        tabsValue={tabsValue}
        handleChange={handleChange}
      />
      <CommissionDetails
        tabsValue={tabsValue}
        selectedWeek={selectedWeek}
        onWeekChange={handleWeekChange}
      />
    </TwoColumnLayout>
  )
}

export default CommissionPage

